import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "domain-graph" }
const _hoisted_2 = { class: "feedback-container" }
const _hoisted_3 = { class: "subtitle section-title" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode()
const _hoisted_6 = { class: "score-display" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "subtitle polarity-title" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = { class: "score-display" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Chart, {
      type: "bar",
      data: _ctx.graphData,
      options: _ctx.options
    }, null, 8, ["data", "options"]),
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.domainSet.title), 1),
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.domainSet.pcZeroStr3), 1)
      ]),
      _createElementVNode("div", {
        class: "all",
        innerHTML: _ctx.domainSet.feedbackText()
      }, null, 8, _hoisted_7),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domainSet.facets, (facet) => {
        return (_openBlock(), _createElementBlock("div", {
          key: ['facet-fb',facet.key].join('-'),
          class: "all"
        }, [
          _createElementVNode("h4", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(facet.title), 1),
            _hoisted_10,
            _createElementVNode("span", _hoisted_11, _toDisplayString(facet.pcZeroStr3), 1)
          ]),
          _createElementVNode("article", {
            innerHTML: facet.feedbackText()
          }, null, 8, _hoisted_12)
        ]))
      }), 128))
    ])
  ]))
}